import { apiClient } from './api';
import type { ApiResponse, PlanInfo, BillingCycle, UsageRecord, Invoice, Organization } from '@/types';

class PlanService {
  async getPlan(): Promise<PlanInfo> {
    const response = await apiClient.get<ApiResponse<PlanInfo>>('/plan');
    if (response.data.data) return response.data.data;
    throw new Error('Failed to get plan info');
  }

  async upgrade(): Promise<Organization> {
    const response = await apiClient.post<ApiResponse<Organization>>('/plan/upgrade');
    if (response.data.data) return response.data.data;
    throw new Error('Failed to upgrade plan');
  }

  async downgrade(): Promise<Organization> {
    const response = await apiClient.post<ApiResponse<Organization>>('/plan/downgrade');
    if (response.data.data) return response.data.data;
    throw new Error('Failed to downgrade plan');
  }

  async getUsage(): Promise<{ cycle: BillingCycle; records: UsageRecord[] }> {
    const response = await apiClient.get<ApiResponse<{ cycle: BillingCycle; records: UsageRecord[] }>>('/plan/usage');
    if (response.data.data) return response.data.data;
    throw new Error('Failed to get usage');
  }

  async getInvoices(): Promise<Invoice[]> {
    const response = await apiClient.get<ApiResponse<Invoice[]>>('/plan/invoices');
    return response.data.data || [];
  }

  async getInvoice(id: string): Promise<Invoice> {
    const response = await apiClient.get<ApiResponse<Invoice>>(`/plan/invoices/${id}`);
    if (response.data.data) return response.data.data;
    throw new Error('Failed to get invoice');
  }

  async getInvoiceHtml(invoiceId: string): Promise<string> {
    const response = await apiClient.get(`/plan/invoices/${invoiceId}/html`, { responseType: 'text' });
    return response.data as unknown as string;
  }

  async sendInvoice(invoiceId: string, email?: string): Promise<void> {
    await apiClient.post(`/plan/invoices/${invoiceId}/send`, email ? { email } : {});
  }
}

export const planService = new PlanService();
